import { Link, useRouterState } from "@tanstack/react-router";

const HIDDEN_PREFIXES = [
  "/app",
  "/sign-in",
  "/sign-up",
  "/forgot-password",
  "/reset-password",
  "/confirm-email",
  "/score",
  "/admin",
  "/dev",
  "/choose-plan",
];

export function SiteFooter() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  if (HIDDEN_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"))) {
    return null;
  }

  const year = new Date().getFullYear();

  return (
    <footer
      style={{
        background: "#1C0828",
        color: "#C8B8D4",
        fontFamily: "var(--font-ui)",
      }}
    >
      <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
        <div className="grid gap-14 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div
              style={{
                fontFamily: "var(--font-serif)",
                fontSize: 36,
                letterSpacing: "-0.02em",
                lineHeight: 1,
              }}
            >
              <span style={{ color: "#FBF7F4" }}>Know</span>
              <span style={{ color: "#FF5C7A" }}>Meno</span>
            </div>
            <p
              className="mt-5 max-w-sm text-[14px] leading-relaxed"
              style={{ color: "#C8B8D4" }}
            >
              Menopause intelligence built on your own daily patterns — and soon, your
              wearable data — clear for you, useful for your doctor.
            </p>
            <div className="mt-6 text-[12px] uppercase tracking-[0.18em]" style={{ color: "#9A86B0" }}>
              Privacy-first · Your data stays yours
            </div>
          </div>


          <FooterCol
            title="Product"
            links={[
              { label: "How it works", href: "/#how" },
              { label: "Insights", href: "/#insights" },
              { label: "For doctors", href: "/#doctors" },
              { label: "Pricing", href: "/#pricing" },
            ]}
          />
          <FooterCol
            title="Resources"
            links={[
              { label: "Menopause guide", href: "/menopause-guide" },
              { label: "34 symptoms", href: "/guide/34-symptoms" },
              { label: "Medical Reset", href: "/medical-reset" },
              { label: "News", href: "/news" },
            ]}
          />
          <FooterCol
            title="Company"
            links={[
              { label: "Privacy", href: "/privacy" },
              { label: "Terms", href: "/terms" },
              { label: "Cookies", href: "/cookies" },
              { label: "Disclaimer", href: "/disclaimer" },
            ]}
          />
        </div>

        <div
          className="mt-16 border-t pt-8 text-[12px] leading-relaxed"
          style={{ borderColor: "rgba(251,247,244,0.12)", color: "#9A86B0" }}
        >
          <p className="max-w-3xl">
            KnowMeno is a personal wellness tracking tool — not a medical device and not a
            substitute for medical advice, diagnosis, or treatment. Always work with a
            qualified healthcare provider.
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-between gap-3">
            <span>© {year} KnowMeno</span>
            <Link to="/" className="hover:opacity-80">English</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({
  title,
  links,
}: {
  title: string;
  links: Array<{ label: string; href: string }>;
}) {
  return (
    <div>
      <div
        className="text-[11px] uppercase tracking-[0.22em]"
        style={{ color: "#9A86B0" }}
      >
        {title}
      </div>
      <ul className="mt-5 space-y-3 text-[14px]" style={{ color: "#FBF7F4" }}>
        {links.map((l) => (
          <li key={l.href}>
            <a href={l.href} className="transition-opacity hover:opacity-60">
              {l.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

